import _kebabCase from 'lodash/kebabCase';
import { Google, Pixall } from '../analytics/index.js';

/**
 * @summary Sends Google Click Event when Mobile Smart Banner is clicked
 */
export async function mobileSmartBannerCTAClick(_ref, option) {
  let {
    data = {},
    dataLayer
  } = _ref;
  const {
    action = 'open',
    text = ''
  } = data;
  const normalizedActionLabel = _kebabCase(action);
  const eventResult = `cta::${normalizedActionLabel}::${_kebabCase(text)}`;
  const eventElement = 'app-deeplink';
  Pixall.sendClickEvent({
    eventSource: 'application',
    eventType: 'click',
    label: eventResult,
    hasListingType: false
  }, dataLayer, option);
  Google.sendClickEvent({
    eventResult,
    eventElement,
    eventNonInteractive: false
  }, option);
  return {};
}

/**
 * @summary Sends Google Impression Event when Mobile Smart Banner is clicked
 */
export async function mobileSmartBannerImpression(metadata, option) {
  const {
    data = {}
  } = metadata;
  const {
    action = 'open',
    text = ''
  } = data;
  const eventResult = `cta::${_kebabCase(action)}::${_kebabCase(text)}`;
  const eventElement = 'app-deeplink';
  Pixall.sendImpression(metadata, {
    eventSource: 'application',
    eventType: 'view',
    label: eventResult,
    pageId: 'atc_h',
    hasListingType: false
  }, option);
  Google.sendImpressions(metadata, {
    eventResult,
    eventElement,
    eventNonInteractive: true
  }, option);
  return {};
}
export default {
  mobileSmartBannerCTAClick,
  mobileSmartBannerImpression
};